export enum WeightUnit {
  G = 0,
  KG = 1
};
